import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import { textCapitalize } from "../../../Helpers/Utils";
import { Skeleton } from "../../../Components/Needed";

const emptyForm = { email_1: "", email_2: "", mobile_1: "", mobile_2: "" };

const validate = (form) => {
    if (!form.email_1?.trim() || !form.email_2?.trim()) return "Both support emails are required";
    if (form.email_1.trim().toLowerCase() === form.email_2.trim().toLowerCase()) return "Email Id must not be the same";
    if (!/^\d{10}$/.test(String(form.mobile_1 || ""))) return "Mobile 1 must be 10 digits";
    if (!/^\d{10}$/.test(String(form.mobile_2 || ""))) return "Mobile 2 must be 10 digits";
    if (form.mobile_1 === form.mobile_2) return "Mobile No must not be the same";
    return "";
};

const SupportTab = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [form, setForm] = useState(emptyForm);

    const load = useCallback(async () => {
        setLoading(true);
        const response = await Handler({ method: "GET", url: "/staff/business/site/support/view" });
        if (response?.success) {
            const data = response?.data?.data || {};
            setForm({
                email_1: data.email_1 || "",
                email_2: data.email_2 || "",
                mobile_1: data.mobile_1 || "",
                mobile_2: data.mobile_2 || "",
            });
        }
        setLoading(false);
    }, []);

    useEffect(() => { load(); }, [load]);

    const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    const onSave = async () => {
        const error = validate(form);
        if (error) {
            toast.error(error);
            return;
        }
        setSaving(true);
        const response = await Handler({
            method: "patch",
            url: "/staff/business/site/support/update",
            data: {
                email_1: form.email_1.trim().toLowerCase(),
                email_2: form.email_2.trim().toLowerCase(),
                mobile_1: form.mobile_1.trim(),
                mobile_2: form.mobile_2.trim(),
            },
        });
        if (response?.success) {
            toast.success(response?.data?.message || "Support details updated");
            load();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to update support details"));
        }
        setSaving(false);
    };

    if (loading) {
        return (
            <div className="settings-card">
                <Skeleton height={24} width="40%" className="mb-3" />
                <Skeleton height={38} className="mb-3" />
                <Skeleton height={38} className="mb-3" />
            </div>
        );
    }

    return (
        <div className="settings-card">
            <h5 className="fw-semibold mb-3">Support Details</h5>
            <p className="text-muted small mb-4">Shown to customers as the ways to reach your support team - two email addresses and two phone numbers, each pair must be distinct.</p>

            <div className="row g-4">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="support-email-1">Support email 1</label>
                    <input id="support-email-1" type="email" name="email_1" className="form-control" value={form.email_1} onChange={handleChange} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="support-email-2">Support email 2</label>
                    <input id="support-email-2" type="email" name="email_2" className="form-control" value={form.email_2} onChange={handleChange} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="support-mobile-1">Support mobile 1</label>
                    <input id="support-mobile-1" type="tel" name="mobile_1" maxLength={10} className="form-control" value={form.mobile_1} onChange={handleChange} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="support-mobile-2">Support mobile 2</label>
                    <input id="support-mobile-2" type="tel" name="mobile_2" maxLength={10} className="form-control" value={form.mobile_2} onChange={handleChange} />
                </div>
            </div>

            <div className="settings-card-actions">
                <button type="button" className="btn btn-primary" onClick={onSave} disabled={saving}>
                    {saving ? "Saving..." : "Save changes"}
                </button>
            </div>
        </div>
    );
};

export default SupportTab;
